import assign from 'lodash/assign';
import some from 'lodash/some';
import uiRouter from '@uirouter/angularjs';
import ngSanitize from 'angular-sanitize';
import $ from 'jquery';
import ngTranslate from 'angular-translate';

import { HotspotModule } from 'admin/components/Hotspot/index.ng';
import { StorageServiceModule } from 'services/storage/storage.service';
import { VideoSliderServiceModule } from 'components/videoSlider/videoSlider.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { StoreInformationServiceModule } from 'services/data/storeInformation.service';

import template from './storefrontSlider.html';
import './storefrontSlider.scss';
import './storefrontSliderSplit.scss';
import { StorefrontSliderServiceModule } from './storefrontSlider.service';

export const StorefrontSliderDirectiveModule = angular
    .module('app.components.storefrontSlider.storefrontSliderDirective', [
        uiRouter,
        ngSanitize,
        ngTranslate,

        HotspotModule,
        StorageServiceModule,
        StorefrontSliderServiceModule,
        VideoSliderServiceModule,
        LaunchDarklyServiceModule,
        StoreInformationServiceModule
    ]).directive('storefrontSlider', (
        $rootScope,
        $window,
        $document,
        $sce,
        $state,
        $timeout,
        storefrontSliderService,
        storageService,
        videoSliderService,
        launchDarklyService,
        storeInformationService
    ) => {
        return {
            restrict: 'E',
            controllerAs: 'storefrontCtrl',
            bindToController: true,
            template,
            replace: true,
            scope: {
                onEvent: '&',
                controls: '=vlnControls'
            },
            link: (scope, element, attrs) => {
                var vm = scope.storefrontCtrl;
                var $body = angular.element('body');

                if (attrs.controls !== '') {
                    vm.controls = {
                        open: vm.open,
                        close: vm.close,
                        edit: vm.edit
                    };
                }

                $body.addClass('storefront-display');

                scope.$on('$destroy', () => {
                    $body.removeClass('storefront-display');
                });
            },
            controller: function storefrontController($scope) {
                let eventManager = [];

                //page references;
                let $body;
                let $iframeWrap;
                let $adminPage;
                let $adminPageHeader;
                let $divider;
                let $storefrontSlider;
                let $mainAppView;
                let $storefrontSliderView;
                let $trialStatusBar;
                let $$window;

                //mouse
                let isMouseDown = false;

                //browser
                let isMobile = $window.matchMedia('(max-width: 599px)');
                let isTablet = $window.matchMedia('(max-width: 959px)');

                let sliderWidth = {
                    pixels: 0,
                    percentage: 0
                };

                let pageWidth = {
                    pixels: 0,
                    percentage: 0
                };

                //constants
                const PAGE_MIN_WIDTH = 512;
                const SLIDER_MIN_WIDTH = 320;
                const NAV_WIDTH_SMALL = 64;
                const NAV_WIDTH_HIDDEN = 0;
                const NAV_WIDTH = 180;
                const SPLIT_VIEW_PAGES = [
                    'product.detail',
                    'product.add',
                    'pages.detail',
                    'pages.add',
                    'category.detail',
                    'category.add',
                    'editstore.landing',
                    'editstore.logo',
                    'editstore.menu',
                    'editstore.styles',
                    'editstore.content.navigation',
                    'editstore.content.editItem',
                    'editstore.installedThemes',
                    'editstore.themedetails'
                ];

                const DEVICE_WIDTH = {
                    mobile: 400,
                    tablet: 770,
                    desktop: 1200
                };

                let hasSiteDesigner = false;

                launchDarklyService.isElementStore(storeInformationService)
                    .then(isElementStore => hasSiteDesigner = isElementStore);

                let vm = assign(this, {
                    isOpen: false,
                    isLoading: false,
                    currentPage: $state.current.name,
                    pageUrl: null,
                    splitViewEnabled: true,
                    canNavigate: true,
                    browserWidth: -1,
                    adminPageBaseWidth: -1,
                    navWidth: 180,
                    DEVICE_WIDTH: DEVICE_WIDTH,
                    isThemePreview: false,
                    hasStorefrontLoaded: false,
                    themeTitle: null,
                    sliderWidth: sliderWidth,
                    SPLIT_VIEW_PAGES: SPLIT_VIEW_PAGES,

                    open,
                    close,
                    edit,
                    toggleSplitView,
                    resize,
                    checkSplitViewSupport,
                    setNavWidth
                });

                $timeout(init);

                function init() {
                    //page references
                    $body = angular.element('body');
                    $iframeWrap = angular.element('.storefront-slider__iframe-wrap');
                    $adminPage = angular.element('.page');
                    $adminPageHeader = angular.element('.page__header');
                    $divider = angular.element('.storefront-slider__divider');
                    $storefrontSlider = angular.element('.storefront-slider');
                    $mainAppView = angular.element('#main-app-view');
                    $storefrontSliderView = angular.element('#storefront-slider-view');
                    $trialStatusBar = angular.element('.trial-status-bar');
                    $$window = angular.element($window);
                    if ($window.localStorage.getItem('splitViewEnabled') !== null) {
                        vm.splitViewEnabled = $window.localStorage.getItem('splitViewEnabled') === 'true';
                    }

                    initEvents();
                    browserResizeHandler();
                    stateChangeHandler(null, $state.current);

                    if (isEditStore($state.current.name)) {
                        setSplitView(true);
                    }

                    storefrontSliderService.getPageUrl().then(setPageUrl);

                    setNavWidth();
                }

                function setNavWidth() {
                    vm.navWidth = $body.hasClass('nav-menu__small') ? NAV_WIDTH_SMALL : NAV_WIDTH;

                    if (isTablet.matches) vm.navWidth = NAV_WIDTH_HIDDEN;
                }

                function setSliderUrl() {
                    return storefrontSliderService.getMerchantUrl().then((response) => {
                        let currentUrl = storefrontSliderService.getSliderUrl();
                        if (currentUrl) {
                            storefrontSliderService.setSliderUrl(currentUrl);
                        } else {
                            storefrontSliderService.setSliderUrl(response);
                        }
                    });
                }

                function initEvents() {
                    eventManager.push($rootScope.$on('$stateChangeStart', stateChangeStartHandler));
                    eventManager.push($rootScope.$on('$stateChangeSuccess', stateChangeHandler));
                    eventManager.push($rootScope.$on('$viewContentLoaded', pageLoadHandler));
                    eventManager.push($rootScope.$on('storefrontSliderService:setUrlBarAddress',
                        (event, data) => setPageUrl(data)));
                    eventManager.push($rootScope.$on('storefrontSliderService:sliderUrlChanged',
                        (event, data) => updateSliderIframe(data)));
                    eventManager.push($rootScope.$on('storefrontSliderService:toggleLoader',
                        (event, data) => toggleLoader(data)));
                    eventManager.push($rootScope.$on('storefrontSliderService:stateChanged',
                        (event, data) => vm.canNavigate = data));
                    eventManager.push($rootScope.$on('storefrontSliderService:openSlider', (e, width) => {
                        getBaseWidths();
                        const newWidth = width || (vm.browserWidth - vm.navWidth);
                        setWidth(sliderWidth, newWidth);
                        setWidth(pageWidth, vm.adminPageBaseWidth - newWidth);
                        vm.open();
                    }));
                    eventManager.push($rootScope.$on('storefrontSliderService:closeSlider', () => {
                        vm.close();
                    }));
                    eventManager.push($rootScope.$on('storefrontSliderService:storeNameChanged',
                        (event, data) => storeNameChangedHandler(data)));

                    $$window.on('resize', browserResizeHandler);
                    $divider.on('mousedown', mouseDownHandler);
                    $body.on('mouseup', mouseUpHandler);
                    $body.on('mousemove', mouseMoveHandler);
                    listenToStorefront();

                    $scope.$on('$destroy', unbindEvents);
                }

                function storeNameChangedHandler(storeUrl) {
                    storefrontSliderService.setSliderUrl(storeUrl);
                    storefrontSliderService.getMerchantUrl(true);
                }

                function unbindEvents() {
                    var event;
                    while ((event = eventManager.pop()) != null) {
                        event();
                    }

                    $$window.off('resize', browserResizeHandler);
                    $divider.off('mousedown', mouseDownHandler);
                    $body.off('mouseup', mouseUpHandler);
                    $body.off('mousemove', mouseMoveHandler);
                }

                function listenToStorefront() {
                    $window.addEventListener('message', processStorefrontMessage);
                    $scope.$on('$destroy', () => {
                        $window.removeEventListener('message', processStorefrontMessage);
                    });
                }

                function processStorefrontMessage(e) {
                    var key = e.message ? 'message' : 'data';
                    var data = e[key];
                    if (data[0] !== '{') {
                        return;
                    }

                    var message = JSON.parse(data);
                    if (message.sender !== 'theme' || e.origin === $window.location.origin) {
                        return;
                    }

                    $rootScope.$emit('storefrontMessageReceived', message);
                    switch (message.event) {
                        case 'angularInitialized':
                            var frame = angular.element('.storefront-slider__iframe-wrap iframe')[0];
                            storefrontSliderService.setIframeReference(frame.contentWindow);
                            $rootScope.$emit('storefrontSliderDirective:angularInitialized');
                            break;
                        case 'urlChanged':
                            vm.pageUrl = message.data;
                            $scope.$apply();
                            break;
                        case 'pageChange':
                            storefrontSliderService.setStorefrontState(message.data);
                            $scope.$apply();
                            break;
                        //no default
                    }
                }

                function toggleLoader(data) {
                    vm.isLoading = data !== undefined ? data : !vm.isLoading;
                }

                function shouldLoadStorefrontEvenIfNotOpen() {
                    return some(vm.SPLIT_VIEW_PAGES, $state.includes) || storefrontSliderService.getSliderHasOpened();
                }

                function updateSliderIframe(data) {
                    const iFrameSourceUrl = new $window.URL(data);
                    iFrameSourceUrl.pathname = `/storefront-preview${iFrameSourceUrl.pathname}`;
                    var waitTime = 0;
                    if (!$iframeWrap || !data || !shouldLoadStorefrontEvenIfNotOpen()) {
                        return;
                    }

                    if (!vm.hasStorefrontLoaded) {
                        waitTime = 1000;
                    }

                    // setting a timeout to avoid the blank page while the iframe loads
                    $timeout(() => {
                        $iframeWrap.html(`<iframe allowpaymentrequest 
frameborder="0" src="${$sce.trustAsResourceUrl(iFrameSourceUrl.href)}">`);
                        var $frame = angular.element('.storefront-slider__iframe-wrap iframe');
                        var frame = $frame[0];
                        $frame.on('load', () => {
                            vm.hasStorefrontLoaded = true;
                            $scope.$apply();
                        });
                        if (angular.isDefined(frame)) {
                            storefrontSliderService.setIframeReference(frame.contentWindow);
                        }
                        vm.isThemePreview = storefrontSliderService.isThemePreview();
                        vm.themeTitle = storefrontSliderService.getThemeTitle();
                    }, waitTime);
                }

                function stateChangeStartHandler(event, toState, toParams, fromState) {
                    if (fromState.name.indexOf('.add') !== -1 && toState.name.indexOf('.detail') !== -1) {
                        return;
                    }

                    if (isEditStore(toState.name)) {
                        return;
                    }

                    storefrontSliderService.goToPage('home');

                    // close slider when navigating away from detail pages
                    if (vm.isOpen) {
                        vm.close();
                    }
                }

                function stateChangeHandler(event, toState) {
                    vm.currentPage = toState.name;

                    refreshPageReference();

                    if (isEditStore(vm.currentPage) && !isMobile.matches) {
                        setSplitView(true);
                        vm.open();
                    } else {
                        toggleSplitView(vm.splitViewEnabled);
                    }
                }

                function setSplitView(val) {
                    vm.splitViewEnabled = val !== undefined ? val : !vm.splitViewEnabled;

                    $body.toggleClass('storefront-slider-split', vm.splitViewEnabled && checkSplitViewSupport());

                    if (vm.splitViewEnabled) {
                        resizeViews();
                    } else {
                        removeDynamicWidths();
                    }
                }

                function toggleSplitView(val) {
                    setSplitView(val);
                    if (storageService.supported()) {
                        $window.localStorage.setItem('splitViewEnabled', vm.splitViewEnabled);
                    }
                }

                function setPageUrl(res) {
                    vm.pageUrl = isAddPage(vm.currentPage) ? '' : res;
                }

                function pageLoadHandler() {
                    //Wait for component to render
                    $timeout(() => {
                        refreshPageReference();
                        storefrontSliderService.getPageUrl().then(setPageUrl);

                        setNavWidth();
                        setWidth(pageWidth, vm.adminPageBaseWidth - sliderWidth.pixels);
                        resizeViews();

                        if (isEditStore(vm.currentPage) && !isMobile.matches) {
                            setSplitView(true);
                            vm.open();
                        }
                    });
                }

                function getBaseWidths() {
                    setNavWidth();
                    const pagePaddingOffset = isTablet.matches ? 0 : 30;
                    vm.browserWidth = $($document).width();
                    vm.adminPageBaseWidth = vm.browserWidth - vm.navWidth - pagePaddingOffset;
                    if (isEditStore($state.current.name)) vm.adminPageBaseWidth = vm.browserWidth;
                }

                function browserResizeHandler() {
                    getBaseWidths();

                    if (!vm.isOpen) { return; }

                    if (vm.splitViewEnabled && isMobile.matches) {
                        vm.close();
                    }

                    setWidth(pageWidth, vm.adminPageBaseWidth - sliderWidth.pixels);
                    setWidth(sliderWidth, sliderWidth.pixels);
                    resizeViews();
                }

                function isWidthWithinThreshold() {
                    return pageWidth.pixels >= PAGE_MIN_WIDTH && sliderWidth.pixels >= SLIDER_MIN_WIDTH;
                }

                function resizeViews() {
                    if (!vm.isOpen) { return; }

                    getBaseWidths();

                    var maxWidth = vm.browserWidth - vm.navWidth;

                    if (vm.splitViewEnabled && checkSplitViewSupport()) {
                        // If widths are not within threshold, force within threshold
                        if (!isWidthWithinThreshold()) {
                            if (pageWidth.pixels < PAGE_MIN_WIDTH) {
                                setWidth(pageWidth, PAGE_MIN_WIDTH);
                                setWidth(sliderWidth, vm.adminPageBaseWidth - PAGE_MIN_WIDTH);
                            } else {
                                setWidth(pageWidth, vm.adminPageBaseWidth - SLIDER_MIN_WIDTH);
                                setWidth(sliderWidth, SLIDER_MIN_WIDTH);
                            }
                        }

                        $adminPageHeader.css('right', `${sliderWidth.percentage}%`);
                        $adminPage.css('width', `${pageWidth.percentage}%`);
                        $trialStatusBar.css('width', `calc(100% - ${sliderWidth.percentage}%)`);
                    } else {
                        if (sliderWidth.pixels > maxWidth) setWidth(sliderWidth, maxWidth);
                        if (sliderWidth.pixels < SLIDER_MIN_WIDTH) setWidth(sliderWidth, SLIDER_MIN_WIDTH);
                    }

                    $storefrontSlider.css('width', `${sliderWidth.percentage}%`);
                    $rootScope.$emit('storefrontSliderDirective:update');

                    if (storageService.supported()) {
                        $window.localStorage.setItem('storefrontSliderWidth', sliderWidth.pixels);
                    }
                }

                function checkSplitViewSupport(page) {
                    page = page || vm.currentPage;
                    var hasSplit = false;
                    if (SPLIT_VIEW_PAGES.indexOf(page) !== -1) hasSplit = true;
                    return hasSplit;
                }

                function mouseDownHandler(e) {
                    if (e.which !== 1) { return; }
                    isMouseDown = true;
                    $body.addClass('storefront-slider-divider--mousedown');
                }

                function mouseUpHandler() {
                    isMouseDown = false;
                    $body.removeClass('storefront-slider-divider--mousedown');
                }

                function mouseMoveHandler(e) {
                    if (!isMouseDown) { return; }
                    const DRAG_THUMB_WIDTH = 13;
                    setWidth(sliderWidth, (vm.browserWidth - e.pageX) + (DRAG_THUMB_WIDTH / 2));
                    setWidth(pageWidth, vm.adminPageBaseWidth - sliderWidth.pixels);
                    resizeViews();
                }

                function setWidth(obj, pixelValue, percentValue) {
                    const page = obj === pageWidth;

                    getBaseWidths();

                    let fullWidth = page ? vm.adminPageBaseWidth : vm.browserWidth;

                    if (pixelValue) {
                        pixelValue = parseFloat(pixelValue);
                        obj.pixels = pixelValue;
                        obj.percentage = (pixelValue / fullWidth) * 100;
                    } else if (percentValue) {
                        percentValue = parseFloat(percentValue);
                        obj.percentage = percentValue;
                        obj.pixels = (fullWidth * percentValue) / 100;
                    }
                }

                // Get fresh DOM elements. Used on page changes
                function refreshPageReference() {
                    $adminPage = angular.element('.page');
                    $adminPageHeader = angular.element('.page__header');
                    $trialStatusBar = angular.element('.trial-status-bar');
                }

                function removeDynamicWidths() {
                    $adminPage.css('width', '');
                    $adminPageHeader.css('right', '');
                    $trialStatusBar.css('width', '');
                }

                function open() {
                    if (vm.isOpen) { return; }
                    videoSliderService.closeSlider();
                    storefrontSliderService.setSliderHasOpened();
                    setSliderUrl().then(() => {
                        vm.isOpen = true;
                        $body.addClass('hide-overflow--mobile storefront-slider-open');
                        $body.removeClass('hide-overflow');
                        $mainAppView = angular.element('#main-app-view');
                        $mainAppView.addClass('safari-mobile-hide');
                        $storefrontSliderView = angular.element('#storefront-slider-view');
                        $storefrontSliderView.removeClass('storefront-slider-view__collapsed');

                        if (!sliderWidth.percentage) {
                            if ($window.localStorage.getItem('storefrontSliderWidth')) {
                                getBaseWidths();
                                var oldSliderWidth = parseFloat($window.localStorage.getItem('storefrontSliderWidth'));
                                setWidth(sliderWidth, oldSliderWidth);
                                setWidth(pageWidth, vm.adminPageBaseWidth - oldSliderWidth);
                            } else {
                                resize('mobile');
                            }
                        }

                        if (sliderWidth.percentage === 100) {
                            // reset from fullscreen resize
                            setWidth(sliderWidth, vm.browserWidth - SLIDER_MIN_WIDTH);
                            setWidth(pageWidth, vm.adminPageBaseWidth - sliderWidth.pixels);
                        }

                        resizeViews();

                        $rootScope.$emit('storefrontSlider:opened');
                    });
                }

                function close() {
                    vm.isOpen = false;
                    $body.removeClass('hide-overflow hide-overflow--mobile storefront-slider-open');
                    $mainAppView = angular.element('#main-app-view');
                    $mainAppView.removeClass('safari-mobile-hide');
                    $storefrontSliderView = angular.element('#storefront-slider-view');
                    $storefrontSliderView.addClass('storefront-slider-view__collapsed');

                    removeDynamicWidths();

                    $rootScope.$emit('storefrontSlider:closed');

                    if (isThemeStorePreview(vm.currentPage)) {
                        storefrontSliderService.goToPage('home');
                    }
                }

                function edit() {
                    if (isMobile.matches) {
                        vm.close();
                    }
                    return $state.go('editstore.landing');
                }

                function isAddPage(page) {
                    return page && page.indexOf('.add') !== -1 && page.indexOf('customer') === -1;
                }

                function isEditStore(page) {
                    if (hasSiteDesigner && page === 'editstore.menu') return false;

                    return page && page.indexOf('editstore') !== -1;
                }

                function isThemeStorePreview(page) {
                    return page && page.indexOf('themestore.themedetails') !== -1;
                }

                function resize(resolution) {
                    if (resolution === 'fullscreen') {
                        $body.addClass('hide-overflow');
                    } else {
                        $body.removeClass('hide-overflow');
                    }

                    switch (resolution) {
                        case 'desktop':
                            setWidth(sliderWidth, DEVICE_WIDTH.desktop);
                            break;
                        case 'tablet':
                            setWidth(sliderWidth, DEVICE_WIDTH.tablet);
                            break;
                        case 'mobile':
                            setWidth(sliderWidth, DEVICE_WIDTH.mobile);
                            break;
                        case 'fullscreen':
                            setWidth(sliderWidth, vm.browserWidth);
                            break;
                        //no default
                    }

                    setWidth(pageWidth, Math.max(vm.adminPageBaseWidth - sliderWidth.pixels, PAGE_MIN_WIDTH));
                    resizeViews();
                }
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/storefrontSlider/storefrontSlider.directive.js